import { AUTH_CHECK, AUTH_ERROR, AUTH_GET_PERMISSIONS, AUTH_LOGIN, AUTH_LOGOUT } from 'react-admin'
import { auth0, login, logout } from './auth/client'

const authProvider = (history) => async (type, params) => {
  console.log('authProvider', type, params)
  if (type === AUTH_LOGIN) {
    await login()
    return
  }

  if (type === AUTH_CHECK) {
    if (await auth0.isAuthenticated()) {
      return
    }
    if (!['/login', '/callback'].includes(window.location.pathname)) {
      sessionStorage.setItem('landingUrl', window.location.pathname)
    }
    await login()
    return
  }

  if (type === AUTH_GET_PERMISSIONS) {
    if (!(await auth0.isAuthenticated())) {
      console.log('User is not authenticated, returning empty permissions')
      return []
    }
    const token = await auth0.getTokenSilently()
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const accessTokenClaims = JSON.parse(window.atob(base64))
    console.log('Access token claims:', accessTokenClaims)
    console.log('Access token scopes:', accessTokenClaims.scope)
    if (typeof accessTokenClaims.scope === 'string') {
      console.log('Access token scopes (string):', accessTokenClaims.scope)
      return accessTokenClaims.scope.split(' ')
    }
    console.log('Access token scopes not found or invalid, returning empty permissions')
    return []
  }

  if (type === AUTH_LOGOUT) {
    await logout()
    return false
  }

  if (type === AUTH_ERROR) {
    // TODO Handle 401 and 403 errors by logging out
    return
  }

  throw new Error('Unknown method')
}

export default authProvider
